import React from "react";
import { PrestacaoContasDetailsPage } from "./prestacaoContasDetails.page";
import { PrestacaoContasDetailsProvider } from "./context/prestacao-contas-details-context";

export function PrestacaoContasDetailsFactory() {
    return (
        <PrestacaoContasDetailsProvider>
            <PrestacaoContasDetailsPage />
        </PrestacaoContasDetailsProvider>
    );
}
